import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { AcsAtaPublicDetails, PotscastPublicDetails } from '../../types/device-details/ata.type';
import { EnclosurePublicDetails } from '../../types/device-details/enclosure.type';
import { rejectWithApiError } from '../../utils/api';
import { OwnershipTransferLog } from '../../types/device-details/device-ownership-logs';

export const getDeviceOwnershipTransferLogs = createAsyncThunk<
  OwnershipTransferLog[],
  { id: number; entityType: string }
>('deviceDetails/getDeviceOwnershipTransferLogs', async ({ id, entityType }, thunkAPI) => {
  try {
    const response = await axios.get<OwnershipTransferLog[]>(
      `${process.env.REACT_APP_API_URL}/logs/ownership-transfer/${id}`,
      { params: { entityType } }
    );
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error fetching device ownership history!' });
  }
});

export const getEnclosureDeviceDetails = createAsyncThunk<EnclosurePublicDetails, { sn: string }>(
  'deviceDetails/getEnclosureDeviceDetails',
  async ({ sn }, thunkAPI) => {
    try {
      const response = await axios.get<EnclosurePublicDetails>(
        `${process.env.REACT_APP_API_URL}/device-lookup/enclosure/${sn}/public-details`
      );
      return response.data;
    } catch (error) {
      return rejectWithApiError({ thunkAPI, error, fallback: 'Error during enclosure device details fetching!' });
    }
  }
);

export const getAcsAtaDeviceDetails = createAsyncThunk<AcsAtaPublicDetails, { sn: string }>(
  'deviceDetails/getAcsAtaDeviceDetails',
  async ({ sn }, thunkAPI) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/device-lookup/ata/${sn}/public-details`);
      return response.data;
    } catch (error) {
      return rejectWithApiError({ thunkAPI, error, fallback: 'Error during ACS ATA device details fetching!' });
    }
  }
);

export const getPotscastDeviceDetails = createAsyncThunk<PotscastPublicDetails, { sn: string }>(
  'deviceDetails/getPotscastDeviceDetails',
  async ({ sn }, thunkAPI) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/device-lookup/potscast/${sn}/public-details`);
      return response.data;
    } catch (error) {
      return rejectWithApiError({ thunkAPI, error, fallback: 'Error during POTSCAST device details fetching!' });
    }
  }
);

export const getRouterDeviceDetails = createAsyncThunk(
  'deviceDetails/getRouterDeviceDetails',
  async ({ sn }: { sn: string }, thunkAPI) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/device-lookup/router/${sn}/public-details`);
      return response.data;
    } catch (error) {
      return rejectWithApiError({ thunkAPI, error, fallback: 'Error during router device details fetching!' });
    }
  }
);

export const getEquipmentGroupDeviceDetails = createAsyncThunk(
  'deviceDetails/getEquipmentGroupDeviceDetails',
  async ({ id }: { id: number }, thunkAPI) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/device-lookup/equipment-group/${id}/public-details`
      );
      return response.data;
    } catch (error) {
      return rejectWithApiError({ thunkAPI, error, fallback: 'Error during equipment group device details fetching!' });
    }
  }
);
